module.exports = __webpack_public_path__ + "img/partners-icon.c57e4347.svg";